import { render, staticRenderFns } from "./servicecomp.vue?vue&type=template&id=32ba582f&scoped=true&"
import script from "./servicecomp.vue?vue&type=script&lang=js&"
export * from "./servicecomp.vue?vue&type=script&lang=js&"
import style0 from "./servicecomp.vue?vue&type=style&index=0&id=32ba582f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ba582f",
  null
  
)

export default component.exports